<script>
import {VueFinalModal} from 'vue-final-modal';

export default {
  name: "SubscriptionModal",
  props: ['modalShow'],
  components: {
    VueFinalModal,
  },
  data() {
    return {
      showModal: this.modalShow,
    }
  },
  methods: {
    modalClose() {
      this.emitter.emit('subscription-modal-close-event', {'eventContent': false})
    }
  }
}
</script>

<template>
  <vue-final-modal
      v-model="showModal"
      @click-outside="modalClose"
      classes="modal-container"
      @click-button="modalClose"
      content-class="modal-content">
    <div class="container-fluid">
      <div class=" d-flex">
        <div class="title">Welcome QuizGiri </div>

      </div>
      <hr>
      <div class="d-flex justify-content-center align-items-center flex-column w-100 text-bold">
        <div>QuizGiri Daily</div>
        <div> LKR 10 + Taxes </div>
        <div> Validity 1 Day </div>
      </div>
      <br>
<!--      <hr>-->
      <button><a href="https://hutch.quizgiri.xyz/purchase/quizgiri-daily" class="text-white">Subscribe (Auto Renewal)</a> </button>

    </div>
  </vue-final-modal>
</template>

<style scoped>
::v-deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

::v-deep .modal-content {
  display: flex;
  flex-direction: column;
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
}

.dark-mode div::v-deep .modal-content {
  border-color: #2d3748;
  background-color: #1a202c;
}
.title {
  font-size: 22px;
  color:black;
  font-weight: bold;
}
button {
  height:40px;
  width:100%;
  background-color: #FF2E75 ;
  border-radius: 8px;
  border:1px solid #FF2E75;
  color: #FFFFFF;
  font-size: 20px;
  font-weight:bold;
}
img {
  margin-top: 10px;
}
</style>